import { render, staticRenderFns } from "./OrmMessageDetail.vue?vue&type=template&id=971ff8ea"
import script from "./OrmMessageDetail.vue?vue&type=script&lang=js"
export * from "./OrmMessageDetail.vue?vue&type=script&lang=js"
import style0 from "./OrmMessageDetail.vue?vue&type=style&index=0&id=971ff8ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports